module.exports = __webpack_public_path__ + "img/mission-icon-1.22b5c212.png";